/* eslint-disable no-extra-parens */
/* eslint-disable react/display-name */
import React, { Suspense, lazy } from 'react';
import ngDeps from '../../common/utilities/ngDependencies';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';

const AirQualityPage = lazy(() => import('./airQualityPage'));

export const AirQualityWrapper = () => {
    return (
        <Suspense fallback={<AirQualityFallbackMarkup />}>
            <AirQualityPage />
        </Suspense>
    );
};

interface AirQualityFallbackMarkupProps {
    isDesktop: boolean;
}
// This will help maintain page structure while we fetch chunks, hence preventing layout shifts and harming out CLS score.
const AirQualityFallbackMarkup =  withScreenSize(({ isDesktop }: AirQualityFallbackMarkupProps) => {
    return (
        <div className='aqi-landing'>
            <div className='aqi-landing__ad__wrapper'>
                <div className='aqi_landing_ad_container'>
                    {
                        !isDesktop
                            ? <div className='aqi_banner_ad'></div>
                            : null
                    }
                </div>
            </div>

            <section className='aqi-info-section'>
                <div className='aqi-info-wrapper'>
                    <h1 className='aqi-page-header'>
                        { (ngDeps as any)?.user?.ActiveLocation?.Locality?.DisplayCompositeName
                            ? `Air Quality - ${(ngDeps as any)?.user?.ActiveLocation?.Locality?.DisplayCompositeName}`
                            : 'Air Quality'
                        }
                    </h1>
                    <div className='aqi-info-widget'></div>
                    <div className='aqi-map'></div>
                </div>
            </section>

            <section className='aqi-summary-and-article-section'>
                <div className='aqi-summary-and-article-section-wraper'>
                    {/* Desktop mark view */}
                    <div className='desktop-view-wrapper'>
                        <div className='aqi-summary-and-articles-desktop'>
                            <div className='aqi-summary-and-articles-desktop-wrapper'>
                                <div className='aqi-summary'>
                                    <div className='aqi-summary-wrapper'>
                                        <div className='aqi-summary-top-triggers'>
                                            <div className='aqi-summary-top-triggers-wrapper'></div>
                                        </div>
                                        <div className='aqi-summary-health-advice'>
                                            <div className='aqi-summary-health-advice-wrapper'></div>
                                        </div>
                                        <div className='aqi-partner-logo'>
                                            <div className='aqi-partner-logo-wrapper'></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='aqi-articles'>
                                    <div className='aqi-articles-wrapper'>
                                        <h3 className='aqi-stories-header'>Air Quality & Asthma</h3>
                                        <div className='aqi-stories'>
                                            <div className='aqi-stories-list'>
                                                {
                                                    Array.from(Array(6).keys()).map((index) => {
                                                        return <div key={`${index}_desktop`} className='aqi-story-item'></div>;
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className='aqi-attribution-logo'>
                                            <div className='aqi-attribution-logo-wrapper'></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='aqi-300x600-ad'></div>
                    </div>

                    {/* Tabelt mark view */}
                    <div className='tablet-view-wrapper'>
                        <div className='aqi-summary-and-ad-tablet'>
                            <div className='aqi-summary-and-ad-tablet-wrapper'>
                                <div className='aqi-summary'>
                                    <div className='aqi-summary-wrapper'>
                                        <div className='aqi-summary-top-triggers'>
                                            <div className='aqi-summary-top-triggers-wrapper'></div>
                                        </div>
                                        <div className='aqi-summary-health-advice'>
                                            <div className='aqi-summary-health-advice-wrapper'></div>
                                        </div>
                                        <div className='aqi-partner-logo'>
                                            <div className='aqi-partner-logo-wrapper'></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='aqi-300x600-ad'></div>
                            </div>
                        </div>
                        <div className='aqi-articles'>
                            <div className='aqi-articles-wrapper'>
                                <h3 className='aqi-stories-header'>Air Quality & Asthma</h3>
                                <div className='aqi-stories'>
                                    <div className='aqi-stories-list'>
                                        {
                                            Array.from(Array(6).keys()).map((index) => {
                                                return <div key={`${index}_tablet`} className='aqi-story-item'></div>;
                                            })
                                        }
                                    </div>
                                </div>
                                <div className='aqi-attribution-logo'>
                                    <div className='aqi-attribution-logo-wrapper'></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Mobile mark view */}
                    <div className='mobile-view-wrapper'>
                        <div className='aqi-summary-top-triggers'>
                            <div className='aqi-summary-top-triggers-wrapper'></div>
                        </div>
                        <div className='aqi-summary-health-advice'>
                            <div className='aqi-summary-health-advice-wrapper'></div>
                        </div>
                        <div className='aqi-partner-logo'>
                            <div className='aqi-partner-logo-wrapper'></div>
                        </div>
                        <div className='aqi-mobile-banner-ad'></div>
                        <div className='aqi-articles'>
                            <div className='aqi-articles-wrapper'>
                                <h3 className='aqi-stories-header'>Air Quality & Asthma</h3>
                                <div className='aqi-stories'>
                                    <div className='aqi-stories-list'>
                                        {
                                            Array.from(Array(6).keys()).map((index) => {
                                                return <div key={`${index}_mobile`} className='aqi-story-item'></div>;
                                            })
                                        }
                                    </div>
                                </div>
                                <div className='aqi-attribution-logo'>
                                    <div className='aqi-attribution-logo-wrapper'></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
});
